import type { ContentTagCategory } from '../types';

export default class ContentTagHelper {
  static hasTags(categories: ContentTagCategory[]): boolean {
    return categories?.some(c => c.tags?.length > 0);
  }

  static getCategoryTagCount = (category: ContentTagCategory): number | string => {
    if (!category.tags?.length) return 0;
    return category.tags.length > 99 ? '99+' : category.tags.length;
  };
}
